// react
import { ReactNode } from 'react';

// mui
import { Grid, Typography } from '@mui/material';

// props
export interface RenderKeyValueParams {
	label: string;
	value: ReactNode;
}

export const RowKeyValue = ({ label, value }: RenderKeyValueParams) => {
	return (
		<Grid alignItems="center" container justifyContent="space-between" spacing={2}>
			<Grid
				item
				sx={(theme) => {
					return {
						[theme.breakpoints.up('lg')]: {
							display: 'none',
						},
					};
				}}
				lg={12}>
				<Typography variant="body2">{label}</Typography>
			</Grid>
			<Grid item xs={true} lg={12} sx={{ textAlign: { xs: 'right', lg: 'left' } }}>
				{value}
			</Grid>
		</Grid>
	);
};
